import { FormattedMessage } from 'react-intl';
import OverlayTrigger from '@rio-cloud/rio-uikit/lib/es/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/lib/es/Tooltip';

import { FillLevelType } from '@/generated/fleetAggregationServiceTypes';
import useHoverIntent from '@/hooks/useHoverIntent';
import AnalyticsEvents from '@/utils/analytics/AnalyticsEvents';
import { isEngineOilTypeDid, isEngineOilTypeV2 } from '@/utils/engineOilUtils';
type InformationSignWithOutdatedTooltipProps = {
    outdatedHours: number;
    tooltipPosition?: string;
    currentPage?: 'diagnostics' | 'filllevels' | 'sidebar';
    oilType?: FillLevelType;
};

export const InformationSignWithOutdatedTooltip = ({ outdatedHours, tooltipPosition, currentPage, oilType }: InformationSignWithOutdatedTooltipProps) => {
    const [hoverRef] = useHoverIntent(1000, () => {
        if (currentPage === 'diagnostics') {
            if (isEngineOilTypeDid(oilType)) {
                AnalyticsEvents.hoverDidDiagnosticsOlder24h();
            } else if (isEngineOilTypeV2(oilType)) {
                AnalyticsEvents.hoverSensorSignalDiagnosticsOlder24h();
            }
        } else if (currentPage === 'filllevels') {
            if (isEngineOilTypeDid(oilType)) {
                AnalyticsEvents.hoverDidFillLevelsOlder24h();
            } else if (isEngineOilTypeV2(oilType)) {
                AnalyticsEvents.hoverSensorSignalFillLevelsOlder24h();
            }
        } else if (currentPage === 'sidebar') {
            if (isEngineOilTypeDid(oilType)) {
                AnalyticsEvents.hoverDidSidebarOlder24h();
            } else if (isEngineOilTypeV2(oilType)) {
                AnalyticsEvents.hoverSensorSignalSidebarOlder24h();
            }
        }
    });

    return (
        <>
            &nbsp;
            <OverlayTrigger
                placement={tooltipPosition}
                overlay={
                    <Tooltip className="width-40ch">
                        <FormattedMessage id="intl-msg:fleetstatus.diagnostics.sidebar.section.engine_oil.olderThanXHours" values={{ hours: outdatedHours }} />
                    </Tooltip>
                }
            >
                <span ref={hoverRef} className="icon rioglyph rioglyph-info-sign text-color-dark" />
            </OverlayTrigger>
        </>
    );
};
